
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Menu } from 'view-design'
import SideMenuItem from './side-menu-item.vue'
import CollapsedMenu from './collapsed-menu.vue'
import { getUnion } from '@/libs/tools'
import mixin from './mixin'
@Component({
    components: {
        SideMenuItem,
        CollapsedMenu
    }
})
export default class SideMenu extends mixins(mixin) {
    @Prop({ default: () => [] })
    readonly menuList!: any[]
    @Prop(Boolean)
    readonly collapsed!: boolean | undefined
    @Prop({ default: 'dark' })
    readonly theme!: string
    @Prop({ default: 20 })
    readonly rootIconSize!: number
    @Prop({ default: 16 })
    readonly iconSize!: number
    @Prop(Boolean)
    readonly accordion!: boolean | undefined
    @Prop({ default: '' })
    readonly activeName!: string
    name = 'SideMenu'
    openedNames: Array<string | undefined> = []
    @Emit('on-select')
    handleSelect(name) {
        return name
    }
    getOpenedNamesByActiveName(name: string) {
        let find: any = this.menuList.find((el) => el.children.find((item) => item.name == name))
        if (find) return [find.name]
        return []
    }
    updateOpenName(name) {
        if (name === this.$config.homeName) {
            this.openedNames = []
        } else {
            this.openedNames = this.getOpenedNamesByActiveName(name)
        }
    }
    get textColor() {
        return this.theme === 'dark' ? '#fff' : '#495060'
    }
    @Watch('menuList')
    onMenuListUpdate(val1, val2) {
        if (val2.length == 0 && this.activeName) {
            this.$nextTick(() => {
                ;(this.$refs.menu as Menu).updateOpened()
                ;(this.$refs.menu as Menu).updateActiveName()
            })
        }
        this.initOpenedNames()
    }
    @Watch('activeName')
    onActiveNameChanged(val: string, oldVal: string) {
        if (this.accordion) {
            this.openedNames = this.getOpenedNamesByActiveName(val)
        } else {
            this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(val))
        }
    }
    @Watch('openedNames')
    onOpenedNamesChanged() {
        this.$nextTick(() => {
            ;(this.$refs.menu as Menu).updateOpened()
        })
    }
    initOpenedNames() {
        if (this.activeName && this.openedNames.length == 0) {
            this.openedNames = this.getOpenedNamesByActiveName(this.activeName)
        }
    }
    created() {
        this.initOpenedNames()
    }
}
